<template>
    <div class="AccessControlCard" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>门禁卡管理</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="门禁卡持有人">
                                    <el-input v-model="queryform.title"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AccessControlCardShow">新增门禁卡</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column prop="cardid" label="门禁卡号">
                    </el-table-column>
                    <el-table-column prop="title" label="门禁卡持有人">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="AccessControlAuthorization(scope.row)">门禁授权</el-button>
                            <el-button type="text" @click="EditAccessControlCard(scope.row)">编辑</el-button>
                            <el-button type="text" @click="DelAccessControlCard(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="AccessControlCard" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="AccessControlCard">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="门禁卡号" prop="cardid">
                            <el-input v-model="form.cardid"></el-input>
                        </el-form-item>
                        <el-form-item label="门禁卡持有人" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.remark"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="AccessControlCard = false">取 消</el-button>
                        <el-button type="primary" @click="SaveAccessControlCard" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog :title="title" :visible.sync="AccessControlAuthorizationShow" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="AccessControlAuthorizationShow" @opened="AccessControlSelect">
                    <el-form :model="forms" :rules="ruless" ref="ruleForms" label-width="120px">
                        <el-form-item label="权限开始时间" prop="dDateS" style="display: inline-block; width: 50%;">
                            <el-date-picker
                                v-model="forms.dDateS"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="权限结束时间" prop="dDateE" style="display: inline-block; width: 50%;">
                            <el-date-picker
                                v-model="forms.dDateE"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <el-table ref="multipleTable" :data="AccessControlListData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" border height="250">
                        <el-table-column type="selection" width="55" align="center">
                        </el-table-column>
                        <el-table-column prop="UID" label="间禁ID">
                        </el-table-column>
                        <el-table-column prop="title" label="间禁号">
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="AccessControlAuthorizationShow = false">取 消</el-button>
                        <el-button type="primary" @click="SaveAccessControlAuth" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "AccessControlCard",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            AccessControlCard: false,
            form: {
                cardid: '',
                title: '',
                remark: ''
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                title: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {},
            confirmloding: false,
            AccessControlAuthorizationShow: false,
            forms: {
                dDateS: '',
                dDateE: ''
            },
            AccessControlListData: [],
            multipleSelection: [],
            userid: '',
            ruless: {
                dDateS: [
                    { required: true, message: '请选择权限开始日期', trigger: 'blur' }
                ],
                dDateE: [
                    { required: true, message: '请选择权限结束日期', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetAccessControlCardList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetAccessControlCardList()
        },
        GetAccessControlCardList () {
            let data = {
                userid: getAdminId(),
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                page: this.currentPage,
                size: this.Size
            }
            if (this.queryform.title) {
                data.title = this.queryform.title
            }
            this.$store.dispatch('AccessControlCardListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                this.tableData = res.data
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                title: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.GetAccessControlCardList()
        },
        SaveAccessControlCard() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            // data.img = JSON.stringify(this.form.img)
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.confirmloding = true
                    that.$store.dispatch('SaveAccessControlCard', data).then(res => {
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.confirmloding = false
                            that.AccessControlCard = false
                            that.fullscreenLoading = true
                            that.GetAccessControlCardList()
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
            
        },
        EditAccessControlCard(row) {
            this.AccessControlCard = true
            this.title = '编辑门禁卡'
            this.form = JSON.parse(JSON.stringify(row))
        },
        DelAccessControlCard(row) {
            this.$confirm('是否删除该门禁卡？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelAccessControlCard', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetAccessControlCardList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        },
        AccessControlCardShow () {
            this.AccessControlCard = true
            this.title = '新增门禁卡'
            this.form = {
                cardid: '',
                title: '',
                remark: ''
            }
        },
        AccessControlAuthorization (row) {
            console.log(row)
            this.userid = row.id
            let data = {
                userid: row.id,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                type: 'C'
            }
            this.title = '门禁授权'
            this.$store.dispatch('AccessControlListShows', data).then(res => {
                if (res.message !== "权限验证失败") {
                    this.AccessControlAuthorizationShow = true
                    this.AccessControlListData = res.data
                    this.forms.dDateS = res.something.dDateS.split(' ')[0]
                    this.forms.dDateE = res.something.dDateE.split(' ')[0]
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    })
                }
            })
        },
        // 确认门禁权限
        SaveAccessControlAuth () {
            let data = {
                userid: this.userid,
                dDateS: this.forms.dDateS,
                dDateE: this.forms.dDateE,
                UIDs: JSON.stringify(this.multipleSelection),
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                type: 'C'
            }
            let that = this
            data.dDateE = data.dDateE + ' ' + '23:59:59'
            this.$refs['ruleForms'].validate((valid) => {
                if (valid) {
                    that.confirmloding = true
                    that.$store.dispatch('SaveAccessControlAuth', data).then(res => {
                        that.confirmloding = false
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.AccessControlAuthorizationShow = false
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    return false;
                }
            })
        },
        handleSelectionChange (selections) {
            this.multipleSelection = selections
        },
        AccessControlSelect () {
            this.AccessControlListData.forEach(row => {
                if (Number(row.is_select) === 1) {
                    this.$refs.multipleTable.toggleRowSelection(row, true);
                } else {
                    this.$refs.multipleTable.toggleRowSelection(row, false);
                }
            });
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetAccessControlCardList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.AccessControlCard {
    width: 100%;
}
.AccessControlCard .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.AccessControlCard .el-header .el-row .el-col h2 {
    text-align: center;
}
.AccessControlCard .el-header .el-row .el-col {
    text-align: center;
}
.AccessControlCard .el-header .el-row .el-col:last-child {
    text-align: right;
}
.AccessControlCard .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.AccessControlCard .el-main .AccessControlAuthorizationShow .el-dialog__body .el-date-editor {
    width: 100%;
}
.AccessControlCard .el-main .AccessControlCard .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
/* .AccessControlCard .el-main .AccessControlCard .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
} */
</style>
